<template>
  <div class="card shadow">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'newsletters' }">Newsletters</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Edit Newsletter
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-body" v-loading="loading">
      <newsletter-item-detail v-if="!loading" :newsletter="newsletter" />
    </div>
  </div>
</template>

<script>
import NewsletterItemDetail from '@/components/Newsletter/Item/NewsletterItemDetail'

export default {
  components: {
    NewsletterItemDetail,
  },

  data() {
    return {
      loading: true,
      newsletter: {},
    }
  },

  async mounted() {
    await this.getNewsletter()
  },

  methods: {
    async getNewsletter() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/newsletters/${ this.$route.params.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.newsletter = data
    },
  },
}
</script>
